import { shouldPushInlineNoticeId } from 'components/uninotice/UniNotice.constants'
import { UniNoticeId } from 'components/uninotice/uninotice.types'

export const shouldRedirectWithPush = (id: UniNoticeId | string) => {
  return shouldPushInlineNoticeId.includes(id as UniNoticeId)
}
